
const camelToSnakeCase = str => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1);

export { camelToSnakeCase, capitalize }
